import store from './redux-store';

export const loadState = () => {
  try {
    const serializedState = window.localStorage.getItem('state');

    if (serializedState === null) {
      return undefined;
    }
    const data = JSON.parse(serializedState);

    // resets redux data to default when new app build appears
    if (data.app.version === process.env.REACT_APP_VERSION) {
      return data;
    }
    window.localStorage.clear();
    window.location.reload();

  } catch (err) {
    window.localStorage.clear();
    window.location.reload();

    return undefined;
  }
};

export const saveState = () => {
  try {
    const serializedState = JSON.stringify(store.getState());
    window.localStorage.setItem('state', serializedState);
  } catch (error) {
    // ignore write errors
  }
};
